module.exports = {
  path: '/playerTeam',
  name: 'playerTeam',
  meta: { title: '球队导入', icon: 'el-icon-upload' },
  component: () => import('../views/playerTeam/playerTeam.vue') //子分类挂载过度,
}
